import {
  type PrefernceType,
  type PreferenceServiceInterface,
  type CurrencyConfig,
  CurrencyCode,
  CurrencyPosition,
  CurrencySymbolOrCode,
  type CurrencyFormatConfig,
} from './types/PreferenceTypes';

/**
 * * PreferenceService
 * @description Service to set and get configurations
 *
 * * @function getPreferences
 *   @returns Object contain local and currency
 *   @description to get values for local and currency
 * * @function setPreferences
 *   @param PrefernceType
 *   @type PrefernceType
 *   @description: to set Preference data
 */
const PreferenceService: PreferenceServiceInterface = (function (root, factory) {
  let preferenceService: PreferenceServiceInterface = {} as PreferenceServiceInterface;
  if (root) {
    // If instance exists use it otherwise create new.
    if (root.PreferenceService) {
      ({ PreferenceService: preferenceService } = root);
    } else {
      root.PreferenceService = preferenceService;
      return factory(preferenceService);
    }
  }

  return preferenceService;
})(
  (typeof window === 'object' && window) || (typeof globalThis === 'object' && globalThis) || this,
  function (PreferenceService: PreferenceServiceInterface) {
    let preferences: PrefernceType = {
      locale: '',
      currency: '',
    };

    const getPreferences = () => preferences;

    const setPreferences = (preferencesData: PrefernceType) => {
      preferences = Object.assign(preferences, preferencesData);
    };

    // Adding methods to Instance.
    PreferenceService.getPreferences = getPreferences;
    PreferenceService.setPreferences = setPreferences;

    return PreferenceService;
  },
);

export { PreferenceService, CurrencyCode, CurrencyPosition, CurrencySymbolOrCode };
export type { PrefernceType, CurrencyConfig, CurrencyFormatConfig };
